import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import Container from '@mui/material/Container';

import LoadingScene from '~/components/MFEProvider/lib/ReactSuspense/LoadingScene';

const HostingRevamp = () => {
  return (
    <Container data-testid="hosting-revamp" disableGutters>
      <Suspense fallback={<LoadingScene />}>
        <Outlet />
      </Suspense>
    </Container>
  );
};

export default HostingRevamp;
